import { render } from "./AddCustomerType.vue?vue&type=template&id=6a0da2a0&scoped=true"
import script from "./AddCustomerType.vue?vue&type=script&lang=js"
export * from "./AddCustomerType.vue?vue&type=script&lang=js"

import "./AddCustomerType.vue?vue&type=style&index=0&id=6a0da2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0da2a0"]])

export default __exports__